import { render, staticRenderFns } from "./HistorySlider.vue?vue&type=template&id=237e0382&scoped=true"
import script from "./HistorySlider.vue?vue&type=script&lang=js"
export * from "./HistorySlider.vue?vue&type=script&lang=js"
import style0 from "./HistorySlider.vue?vue&type=style&index=0&id=237e0382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e0382",
  null
  
)

export default component.exports